export default __webpack_public_path__ + "static/media/kg.0430bdd6.svg";